//auth
export const API_LOGIN = "/user/login";
export const API_LOGOUT = "/user/logout";

// import
export const API_IMPORT_ALL_KITE_EXCHANGE = "/import/importallkite";
export const API_ALL_KITE_EXCHANGE_LIST = "/import/getKiteInstruments";
export const API_ALL_KITE_EXCHANGE_IMPORT = "/import/importInstrument";
export const API_EXPIRED_INSTRUMENT_LIST = "/import/expireInstrument";
export const API_REMOVE_EXPIRED_INSTRUMENT = "/import/removeExpireInstrument";

// instrument
export const API_INSTRUMENT_LIST = "/instruments/list";
export const API_INSTRUMENT_UPDATE = "/instruments/update";
export const API_INSTRUMENT_DELETE = "/instruments/delete";
export const API_INSTRUMENT_FILTER = "/instruments/filterExhangeList";
export const API_INSTRUMENT_BADLA_LIST = "/instruments/isBadlalist";

// exchange
export const API_EXCHANGE_LIST = "/exchange";
export const API_EXCHANGE_CREATE = "/exchange/create";
export const API_EXCHANGE_UPDATE = "/exchange/update";
export const API_EXCHANGE_DELETE = "/exchange/delete";

// badla instrument
export const API_BADLA_INSTRUMENT_LIST = "/badlainstruments/get";
export const API_BADLA_INSTRUMENT_CREATE = "/badlainstruments/create";
export const API_BADLA_INSTRUMENT_UPDATE = "/badlainstruments/update";
export const API_BADLA_INSTRUMENT_DELETE = "/badlainstruments/delete";
export const API_BADLA_INSTRUMENT_DEFAULTUPDATE =
  "/badlainstruments/updateDefault";

// badla setting
export const API_BADLA_SETTING_LIST = "/badlasetting";
export const API_BADLA_SETTING_CREATE = "/badlasetting/create";
export const API_BADLA_SETTING_UPDATE = "/badlasetting/update";
export const API_BADLA_SETTING_DELETE = "/badlasetting/delete";

// badla setting
export const API_DOLLAR_RATE_LIST = "/dollerrate/get";
export const API_DOLLAR_RATE_UPDATE = "/dollerrate/updateprice";
